import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Divider,
  Grid,
  Box,
  Button,
} from "@mui/material";
import { toast } from "react-toastify";

const BillDetailsComponent = ({billDetails,onCancel,billerId,message,validateBiller,initChannels,paymentModes,service }) => {
  console.log("InsidebillDetails");
  console.log("BillDetails", billDetails);
  // Check if billDetails is not available
  if (!billDetails) {
    return (
      <Card
        style={{
          marginTop: "2rem",
          padding: "1rem",
          backgroundColor: "#f5f5f5",
          borderRadius: "12px",
          textAlign: "center",
        }}
      >
        {message && (
          <CardContent>
            <Typography
              variant="h6"
              style={{ fontWeight: "bold", color: "#FF5733" }}
            >
              {message || "No bill details available."}
            </Typography>
          </CardContent>
        )}
      </Card>
    );
  }

  const handlePayNow = async () => {
    try {
      const token = sessionStorage.getItem("jwtToken");

      const response = await fetch(
       `https://api.ipaisa.co.in/myapp/billPayments/billpay?service=${service}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            billerId: billerId,
            enquiryReferenceId: billDetails.enquiryReferenceId,
            inputParameters: {
              param1: billDetails.CustomerParamsDetails?.[0]?.Value || "",
              param2: billDetails.CustomerParamsDetails?.[1]?.Value || "",
            },
            transactionAmount: billDetails.BillAmount,
            initChannel:initChannels,
            paymentModes:paymentModes,
            validateBiller:validateBiller

         
          }),
        }
      );

      const result = await response.json();

      if (
        response.ok &&
        result.data?.body?.response?.status === "Transaction Successful" &&
        result.data?.body?.statusCodeValue === 200
      ) {
        console.log("Payment Response:", result);
        toast.success(result.data?.body?.response?.status); // Show success toast
      } else {
        toast.error(message);
        throw new Error(result.message || "Payment failed");
      }
    } catch (error) {
      console.error("Payment Error:", error);
      toast.error(error.message || "Payment failed"); // Show error toast
    }
  };

  return (
    <Card
      style={{
        marginTop: "2rem",
        padding: "1rem",
        backgroundColor: "#f5f5f5",
        borderRadius: "12px",
      }}
    >
      <CardContent>
        <Typography
          variant="h6"
          style={{ fontWeight: "bold", textAlign: "center", color: "#027BFE" }}
        >
          Bill Details
        </Typography>
        <Divider style={{ margin: "1rem 0" }} />

        <Typography
          variant="subtitle1"
          style={{ fontWeight: "bold", color: "#333" }}
        >
          Customer Details
        </Typography>
        <Grid container spacing={2} style={{ marginBottom: "1rem" }}>
          <Grid item xs={12} md={6}>
            <Typography>
              <strong>Name:</strong> {billDetails.CustomerName || "null"}
            </Typography>
          </Grid>
        </Grid>
        <Divider style={{ margin: "1rem 0" }} />

        <Typography
          variant="subtitle1"
          style={{ fontWeight: "bold", color: "#333" }}
        >
          Bill Details
        </Typography>
        <Grid container spacing={2} style={{ marginBottom: "1rem" }}>
          <Grid item xs={12} md={6}>
            <Typography>
              <strong>Bill Number:</strong> {billDetails.BillNumber || "null"}
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography>
              <strong>Bill Amount:</strong> ₹{billDetails.BillAmount || "null"}
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography>
              <strong>Bill Due Date:</strong>{" "}
              {billDetails.BillDueDate || "null"}
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography>
              <strong>Bill Period:</strong> {billDetails.BillPeriod || "null"}
            </Typography>
          </Grid>
        </Grid>
        <Divider style={{ margin: "1rem 0" }} />

        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Typography
              variant="subtitle1"
              style={{ fontWeight: "bold", color: "#333" }}
            >
              Customer Parameters
            </Typography>
            <Box
              style={{
                padding: "0.5rem 1rem",
                backgroundColor: "rgba(41, 83, 251, 0.47)",
                borderRadius: "12px",
                marginTop: "3%",
              }}
            >
              {billDetails.CustomerParamsDetails?.length > 0 ? (
                billDetails.CustomerParamsDetails.map((detail, index) => (
                  <Typography key={index}>
                    <strong>{detail?.Name || "N/A"}:</strong>{" "}
                    {detail?.Value || "N/A"}
                  </Typography>
                ))
              ) : (
                <Typography>No customer parameters available</Typography>
              )}
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography
              variant="subtitle1"
              style={{ fontWeight: "bold", color: "#333" }}
            >
              Additional Details
            </Typography>
            <Box
              style={{
                padding: "0.5rem 1rem",
                backgroundColor: "rgba(41, 83, 251, 0.47)",
                borderRadius: "12px",
                marginTop: "3%",
              }}
            >
              {billDetails.AdditionalDetails?.length > 0 ? (
                billDetails.AdditionalDetails.map((detail, index) => (
                  <Typography key={index}>
                    <strong>{detail?.Name || "N/A"}:</strong>{" "}
                    {detail?.Value || "N/A"}
                  </Typography>
                ))
              ) : (
                <Typography>No additional details available</Typography>
              )}
            </Box>
          </Grid>
        </Grid>
        <Divider style={{ margin: "1rem 0" }} />
        <Grid container spacing={2} justifyContent="center">
          <Grid item>
            <Button variant="contained" color="primary" onClick={handlePayNow}>
              Pay Now
            </Button>
          </Grid>
          <Grid item>
            <Button variant="outlined" color="secondary" onClick={onCancel}>
              Cancel
            </Button>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default BillDetailsComponent;
